import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import { Table, Pagination, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useLanguage from '../../Hooks/useLanguage';
const TicketManagement = () => {
    const [tickets, setTickets] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    useLanguage();
    const { t } = useTranslation();
    const navi = useNavigate();
    // useEffect(() => {
    //     const fetchTickets = async () => {
    //         setLoading(true);
    //         try {
    //             const token = Cookies.get('Token');
    //             console.log("Token:", token); // Kiểm tra token có giá trị hay không

    //             const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/tickets`, {
    //                 headers: { Authorization: `Bearer ${token}` },
    //             });
    //             console.log("API Response:", response); // Kiểm tra phản hồi từ API

    //             const sortedTickets = response.data?.sort((a, b) => new Date(b.date) - new Date(a.date));
    //             setTickets(sortedTickets);
    //             setLoading(false);
    //         } catch (err) {
    //             console.error("API Error:", err.response || err.message);
    //             setError('Lỗi khi tải dữ liệu');
    //             setLoading(false);
    //         }
    //     };
    //     fetchTickets()
    // }, []);

    useEffect(() => {
        const fetchTickets = async () => {
            setLoading(true);
            try {
                const token = Cookies.get('Token');
                console.log("Token:", token); // Kiểm tra token

                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/tickets`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                console.log("API Response:", response.data); // Kiểm tra API phản hồi

                // Kiểm tra API trả về đúng format không
                if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    // Sắp xếp danh sách tickets theo ngày
                    const sortedTickets = response.data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
                    setTickets(sortedTickets);
                } else {
                    console.error("Invalid API Response Format", response.data);
                    setError("Dữ liệu API không hợp lệ");
                }
                setLoading(false);
            } catch (err) {
                console.error("API Error:", err.response || err.message);
                setError('Lỗi khi tải dữ liệu');
                setLoading(false);
            }
        };

        fetchTickets();
    }, []);


    const filteredTickets = tickets.filter((ticket) => {
        return (
            (!statusFilter || ticket.status === parseInt(statusFilter)) &&
            (!searchQuery || ticket.subject.toLowerCase().includes(searchQuery.toLowerCase()))
        );
    });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredTickets.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(filteredTickets.length / rowsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };
    const handleCreateTicket = () => {
        navi('/tickets/add');
    };



    return (
        <div className="container mt-4">
            <div className="box__service">
                <div className="box__service__header mb-4">
                    <div className="d-flex align-items-center">
                        <div className="d-flex w-100">
                            <div className="form-group d-flex position-relative me-2" style={{ width: '250px' }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Tìm kiếm nhanh"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                            <div className="package__sort">
                                <select
                                    className="form-select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    style={{ width: '180px' }}
                                >
                                    <option value="">{t("Ticket Status")}</option>
                                    <option value="0">{t("Open")}</option>
                                    <option value="1">{t("Answered")}</option>
                                    <option value="2">{t("Customer Reply")}</option>
                                    <option value="3">{t("Closed")}</option>
                                    <option value="4">{t("In Progress")}</option>

                                </select>
                            </div>


                        </div>
                        <div style={{ margin: "0px", padding: "0px" }} className="d-flex justify-content-end">
                            <div style={{ width: '100px' }}>
                                <button className="btn btn-primary" onClick={handleCreateTicket}>
                                    Tạo ticket
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="box__service__content">
                    {loading ? (
                        <div className="text-center">Đang tải dữ liệu...</div>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span>
                                    {filteredTickets.length} {t("Records Found")}, {t("Showing")} {indexOfFirstRow + 1} {t("to")}{' '}
                                    {Math.min(indexOfLastRow, filteredTickets.length)}
                                </span>
                                <Form.Select
                                    value={rowsPerPage}
                                    onChange={handleRowsPerPageChange}
                                    style={{ width: '150px' }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </Form.Select>
                            </div>

                            <div className="table-responsive">
                                <Table bordered hover>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Ticket ID</th>
                                            <th>{t("Title")}</th>
                                            <th>{t("Creation date")}</th>
                                            <th>{t("Priority level")}</th>
                                            <th>{t("Status")}</th>
                                            <th>{t("Action")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRows.length > 0 ? (
                                            currentRows.map((ticket, index) => (
                                                <tr key={ticket.id}>
                                                    <td>{indexOfFirstRow + index + 1}</td>
                                                    <td>{ticket.id}</td>
                                                    <td>{ticket.subject}</td>
                                                    <td>{new Date(ticket.date).toLocaleDateString('en-GB')}</td>
                                                    <td>
                                                        {ticket.priority === 1 ? t("Low") : ticket.priority === 2 ? t("Medium") : t("High")}
                                                    </td>
                                                    <td>
                                                        <span
                                                            className="badge"
                                                            style={{
                                                                backgroundColor: ticket.status === 0 ? '#28A745' :
                                                                    ticket.status === 1 ? '#FFC107' :
                                                                        ticket.status === 2 ? '#007bff' :
                                                                            ticket.status === 3 ? '#A71D2A' : '#FD7E14',
                                                                color: ticket.status === 1 ? '#000' : '#fff',
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {ticket.status === 0 ? "Open" :
                                                                ticket.status === 1 ? "Answered" :
                                                                    ticket.status === 2 ? "Customer Reply" :
                                                                        ticket.status === 3 ? "Closed" : "In Progress"}
                                                        </span>
                                                    </td>


                                                    <td>
                                                        <a
                                                            href={`/tickets/${ticket.id}`}
                                                            style={{ textDecoration: "none" }}
                                                        >
                                                            {t("Detail")}
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    Không có dữ liệu
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            <div className="d-flex justify-content-center mt-4">
                                <Pagination>
                                    <Pagination.Prev
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        {t("Previous")}
                                    </Pagination.Prev>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <Pagination.Item
                                            key={i + 1}
                                            active={i + 1 === currentPage}
                                            onClick={() => handlePageChange(i + 1)}
                                        >
                                            {i + 1}
                                        </Pagination.Item>
                                    ))}
                                    <Pagination.Next
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        {t("Next")}
                                    </Pagination.Next>
                                </Pagination>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TicketManagement;
